<div class="attachments-max-file-size-info">
    <ng-content></ng-content>
</div>